angular.module("app").factory("CategoryService", CategoryService);

// CategoryService.$inject = ["$resource", "CommonCallback"];

function CategoryService($resource, apiUrl, resourceInterceptor) {
  return $resource(
    "",
    {},
    {
      search: {
        url: apiUrl + "/category",
        method: "GET",
        interceptor: resourceInterceptor,
      },
      updateStatus: {
        method: "POST",
        url: apiUrl + "/category/updateStatus",
        interceptor: resourceInterceptor,
      },
      uploadImg: {
        url: apiUrl + "/category/uploadImgCMS",
        method: "PUT",
        headers: { "Content-Type": undefined },
        transformRequest: angular.identity,
        interceptor: resourceInterceptor,
      },
    }
  );
}
